import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.warn(
    '[andrade] Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no arquivo .env',
  );
}

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    storage: typeof sessionStorage !== 'undefined' ? sessionStorage : undefined,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

export const FUNCTIONS_URL = url
  ? `${url.replace(/\/$/, '')}/functions/v1`
  : '';
